export default function staticLoader({ src }: {src: string}) {
    return `${src}`; // REPLACE WITH YOUR IMAGE DIRECTORY
}
